module.exports = __webpack_public_path__ + "static/media/undraw_location_review_dmxd.3a52086f.svg";